module.exports = __webpack_public_path__ + "img/graphic-4.6ab88846.png";